module.exports = __webpack_public_path__ + "static/menu.33fff717.svg";